var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center"},[_c('v-radio-group',{attrs:{"value":_vm.value,"row":""},on:{"change":_vm.onValueChange}},[_c('v-radio',{attrs:{"label":_vm.$t('SYSTEM_ACTIVE'),"value":true}}),_c('v-radio',{attrs:{"label":_vm.$t('SYSTEM_INACTIVE'),"value":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }